module.exports = __webpack_public_path__ + "static/media/nick.a985cb25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nick.png
// module id = 103
// module chunks = 0